import { action } from 'typesafe-actions'
import { Tag } from '@models/tag'
import {RequestData} from "@models/axios";



export const enum TagsActionTypes {
    FETCH_REQUEST = '@@tags/FETCH_REQUEST',
    FETCH_SUCCESS = '@@tags/FETCH_SUCCESS',
    FETCH_ERROR = '@@tags/FETCH_ERROR',

    DELETE_REQUEST = '@@tags/DELETE_REQUEST',
    DELETE_SUCCESS = '@@tags/DELETE_SUCCESS',
    DELETE_ERROR = '@@tags/DELETE_ERROR',

    CREATE_REQUEST = '@@tags/CREATE_REQUEST',
    CREATE_SUCCESS = '@@tags/CREATE_SUCCESS',
    CREATE_ERROR = '@@tags/CREATE_ERROR',

    UPDATE_REQUEST = '@@tags/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@tags/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@tags/UPDATE_ERROR',
}



export const fetchRequest = (data:RequestData) => action(TagsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Tag[]) => action(TagsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(TagsActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(TagsActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(TagsActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(TagsActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(TagsActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Tag[]) => action(TagsActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(TagsActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(TagsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Tag[]) => action(TagsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(TagsActionTypes.UPDATE_ERROR, message);